import { render, staticRenderFns } from "./Gudingweizhishangping.vue?vue&type=template&id=105e15e0&scoped=true&"
import script from "./Gudingweizhishangping.vue?vue&type=script&lang=js&"
export * from "./Gudingweizhishangping.vue?vue&type=script&lang=js&"
import style0 from "./Gudingweizhishangping.vue?vue&type=style&index=0&id=105e15e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105e15e0",
  null
  
)

export default component.exports